import React from 'react'
import { Switch, Route } from "react-router-dom"
import VisaPackages from './visa-packages.page'
import CreateVisaPackage from './create/create.page'
import EditVisaPackage from './edit/edit.page'

const VisaPackageController = () => {
    return (
        <Switch>
            <Route path="/content/visa-packages/edit/:id" component={EditVisaPackage} />
            <Route path="/content/visa-packages/create" component={CreateVisaPackage} />
            <Route exact path="/content/visa-packages" component={VisaPackages} />
        </Switch>
    )
}

export default VisaPackageController
